import { useNavigate } from "react-router-dom"
import { FullscreenDialog } from "../components/dialog/FullscreenDialog"
import { AdminSettingsPage } from "./AdminSettingsPage"

/**
 * AdminSettingsDialog - Wrapper component that renders AdminSettingsPage in a fullscreen dialog
 * Used as a nested route within Dashboard to prevent section reloads
 */
export const AdminSettingsDialog = () => {
  const navigate = useNavigate()

  const handleClose = () => {
    navigate("/")
  }

  return (
    <FullscreenDialog open={true} onClose={handleClose} title="Admin Settings">
      <AdminSettingsPage />
    </FullscreenDialog>
  )
}
